import PointAndClick from './PointAndClick.js';

import { Colors } from '../../consts/Colors.js';
import QuestionPanel_1 from '../../prefabs/chapitre5/questions/QuestionPanel_01.js';
import QuestionPanel_2 from '../../prefabs/chapitre5/questions/QuestionPanel_02.js';
import QuestionPanel_3 from '../../prefabs/chapitre5/questions/QuestionPanel_03.js';
import DebriefPanel from '../../prefabs/chapitre5/DebriefPanel.js';
import DOMVideo from '../../prefabs/chapitre5/video/DOMVideo.js';


export default class Chapitre5_2 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre5_2"
        })
    }

    init(data){
        this.audioName = 'RewardsOfRisk';
        super.init(data);   
    }

    create(){
        super.create();
        this.animIn(() => {this.displayButtons();} );     
        
        this.buttons.forEach(button => {
            button.depth = 1
        })

        this.videoImage = this.add.image(614, 109, 'Chapitre5_2_video').setOrigin(0);

    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "video"){
            
            // Ajout des elements
            this.openVideo(data.url)
        }
    }

    openVideo(url){
        if(this.video)
            return

        // this.blurBackground();
        this.hideButtons();
        this.tweens.add({
            targets: this.videoImage,
            alpha: 0,
            duration: 50,
        })

        // On zoom sur le fond
        this.tweens.add({
            targets: this.background,
            scale: 1.53,
            x:-293,
            y:-31,
            duration: 300,
        })

        // Change la musique
        this.soundManager.playAudio('DangerAhead')

        // Affiche le panneau de question
        this.addQuestionPanel();

        // // Ajout video
        this.video = new DOMVideo(this, 740, 135, "assets/iframe/video/video.mp4")
        this.video.depth = 100
        this.video.setAlpha(0)
        this.tweens.add({
            targets: this.video,
            alpha: 1,
            duration: 500,
        })
    }

    closePopup(){
        super.closePopup();

        // On remet le fond à sa place
        this.tweens.add({
            targets: this.background,
            scale: 1,
            x:0,
            y:0,
            duration: 100,
        })

        if(this.video){
            this.video.delete();
            this.video = null;
        }
    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre5_3")
            }
        })
    }

    animIn(endFunction){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                if(endFunction){
                    endFunction();
                }
            }
        })
    }

    addQuestionPanel(){
        const num = this.chapitreProgression.video.question
        switch(num){
            case 1:
                this.addQuestionPanel1()
                break;
            case 2:
                this.addQuestionPanel2()
                break;
            case 3:
                this.addQuestionPanel3()
                break;
        }
    }

    // Panneau de question qui s'ouvre une fois l'enquete débutée
    addQuestionPanel1(){
        this.chapitreProgression.video.question = 1;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_1(this, 0, 0, {config: this.config.questions[0], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 100
        this.questionPanel.animIn();
    }

    addQuestionPanel2(){
        this.chapitreProgression.video.question = 2;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_2(this, 0, 0, {config: this.config.questions[1], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 100
        this.questionPanel.animIn();
    }
    addQuestionPanel3(){
        this.chapitreProgression.video.question = 3;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_3(this, 0, 0, {config: this.config.questions[2], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 100
        this.questionPanel.animIn();
    }

    addDebrief(){
        this.video.setVisible(false);   
        this.video.delete();
        this.video = null;

        this.debrief = new DebriefPanel(this)
        this.debrief.depth = 100
        this.debrief.animIn();
    }

    closeDebrief(){
        this.animOut()
    }

    closePanelQuestion(endFunc){
        if(this.questionPanel == null || this.questionPanel == undefined) return;

        // Ferme le panneau de question
        this.questionPanel.animOut(() => {
            this.questionPanel.destroy(true);
            this.questionPanel = null;

            if(endFunc)
                endFunc(this);
        })
    }

    // Rectangle Vrai/Faux qui s'affiche après validation de la réponse
    showReponsePopUp({text, isTrue, isLast = false, endFunc}){
        super.showReponsePopUp({text, isTrue, isLast, endFunc});
        this.tweens.add({
            targets: this.video,
            alpha: 0,
            duration: 200,
        })
    }

    closeReponsePopUp(){
        this.reponsePopup.animOut(()=>{
            if(this.video){
                this.video.setVisible(true);
                this.tweens.add({
                    targets: this.video,
                    alpha: 1,
                    duration: 200,
                })
            }
        })
    }

    addPopUpAide(text){
        super.addPopUpAide(text);
        this.tweens.add({
            targets: this.video,
            alpha: 0,
            duration: 200,
        })
    }

    hidePopUpAide(){
        super.hidePopUpAide();
        this.tweens.add({
            targets: this.video,
            alpha: 1,
            duration: 200,
        })
    }

}